module.exports = __webpack_public_path__ + "img/public/SiteIcons/becomeaHostIcon.svg?766700d6";